module.exports = __webpack_public_path__ + "img/制御工学5_7_5.8f99d6f0.png";